import React, { useEffect } from "react";
import CartItem from "../components/Reusable/CartItem";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchCartItems } from "../actions/global";
import { useSelector } from "react-redux";
const formattedPrice = (price) => {
  if (price == null || price === "") return "0,00";

  // Pretvori u broj
  const number = Number(price);

  // Formatiraj sa hiljadarkama i dve decimale
  return number
    .toFixed(2) // obavezno dve decimale
    .replace(".", ",") // decimalna tačka → zarez
    .replace(/\B(?=(\d{3})+(?!\d))/g, "."); // hiljadarke tačka
};

const Cart = () => {
  const dispatch = useDispatch();

  const { dataCartItems } = useSelector((state) => state.globalReducer);

  useEffect(() => {
    dispatch(fetchCartItems());
  }, [dispatch]);

  return (
    <div class="cart-holder-main-content">
      <h1>Vaša korpa</h1>
      <div class="cart-content-main">
        <div class="cart-content-table-holder">
          <table class="table">
            <thead>
              <tr>
                <th>Proizvod</th>
                <th class="text-end">Cena</th>
                <th class="text-end">Količina</th>
                <th class="text-end">Međuzbir</th>
                <th class="text-end">Obriši</th>
              </tr>
            </thead>
            <tbody>
              {dataCartItems?.items?.map((item) => (
                <CartItem key={item.id} item={item} />
              ))}
            </tbody>
          </table>
        </div>
        <div class="cart-content-total-price-holder">
          <div class="cart-content-total-left-side">
            <div class="cart-content-continue-shopping">
              <Link to="/">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="arrow-left"
                  class="svg-inline--fa fa-arrow-left "
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path
                    fill="currentColor"
                    d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
                  ></path>
                </svg>{" "}
                Nastavi sa kupovinom
              </Link>
            </div>
          </div>
          <div class="cart-content-total-right-side">
            <div class="cart-content-total-total d-flex justify-content-between gap-5 mb-4">
              <div class="cart-content-total-total-title">Ukupno</div>
              <div class="cart-content-total-total-price">
                {formattedPrice(dataCartItems?.amount)} RSD
              </div>
            </div>
            <div class="cart-content-total-button-holder">
              <Link to="/checkout">
                <button class="button-custom-black w-100">
                  Nastavite na plaćanje
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
